// extracted by mini-css-extract-plugin
export default {"legendWrapper":"SkeletonTreemapLegend_legendWrapper__K2oNs","entry":"SkeletonTreemapLegend_entry__wpoO8"};